import formatPriceRequest from './formatPriceRequest';
import getPriceBreakdownKey from './getPriceBreakdownKey';
import getCruisePriceBreakdownTotals from './getCruisePriceBreakdownTotals';

const computeCruiseTotals = ({
  trip, priceBreakdowns, passengers, bookingResponses,
}) => {
  let newTotals = { commission: { amount: 0 } };
  if (trip && trip.cruiseItinerary) {
    const key = getPriceBreakdownKey(formatPriceRequest({
      itinerary: trip.cruiseItinerary,
      passengers,
      bookingResponses,
    }));
    if (priceBreakdowns && priceBreakdowns[key]) {
      newTotals = getCruisePriceBreakdownTotals(priceBreakdowns[key], trip && trip.cruisePayments);
    } else newTotals = null;
  }

  return newTotals;
};

export default computeCruiseTotals;
